module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('figure', [_c('p', {
    staticClass: "image2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Iris Munguía...",
      "height": "253",
      "src": "images/f0xiv-01.jpg",
      "width": "465"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Iris Munguía (COSIBAH), Gloria García (SITRATERCO), Zoila Lagos (COSIBAH), and Domitila Hernández (SITRAESISA), near Omoa, Cortés, Honduras, returning from COSIBAH workshops in Guatemala, November 2002 (left to right).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b398098","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Image2.vue
// module id = 81
// module chunks = 0